{
   "name": "platform-vue-app",
   "type": "module",
   "version": "0.9.7",
   "private": true,
   "scripts": {
      "dev": "vite --port 4000",
      "build": "run-p type-check \"build-only {@}\" --",
      "preview": "vite preview",
      "build-only": "vite build",
      "test": "vitest",
      "type-check": "vue-tsc --build --force",
      "lint": "eslint . --fix"
   },
   "dependencies": {
      "@floating-ui/vue": "^2.0.1",
      "@googlemaps/js-api-loader": "^2.1.1",
      "@googlemaps/markerclusterer": "^2.6.2",
      "@iconify/vue": "^5.0.1",
      "@tato30/vue-pdf": "^2.1.0",
      "@types/canvas-confetti": "^1.9.0",
      "@unovis/ts": "^1.6.7",
      "@unovis/vue": "^1.6.7",
      "@vee-validate/zod": "^4.15.1",
      "@vueuse/core": "^14.4.0",
      "apexcharts": "^6.6.1",
      "aws-amplify": "^6.19.0",
      "dompurify": "^3.4.12",
      "launchdarkly-vue-client-sdk": "^2.5.1",
      "marked": "^18.0.7",
      "ofetch": "^1.5.1",
      "papaparse": "^5.5.4",
      "pinia": "^4.0.2",
      "pluralize": "^8.0.0",
      "supercluster": "^8.0.1",
      "vee-validate": "^4.15.1",
      "vue": "^3.5.40",
      "vue-router": "^5.2.0",
      "vue3-apexcharts": "^1.11.1"
   },
   "devDependencies": {
      "@antfu/eslint-config": "^9.2.0",
      "@aws-sdk/client-cognito-identity-provider": "^3.1098.0",
      "@tsconfig/node22": "^22.0.5",
      "@types/dompurify": "^3.2.0",
      "@types/google.maps": "^3.65.3",
      "@types/node": "^26.1.2",
      "@types/papaparse": "^5.5.2",
      "@types/pluralize": "^0.0.33",
      "@types/supercluster": "^7.1.3",
      "@vitejs/plugin-vue": "^6.0.8",
      "@vue/eslint-config-typescript": "^14.9.0",
      "@vue/test-utils": "^2.4.11",
      "@vue/tsconfig": "^0.9.1",
      "autoprefixer": "^10.5.4",
      "canvas-confetti": "^1.9.4",
      "daisyui": "^4.12.24",
      "dayjs": "^1.11.21",
      "eslint": "^10.8.0",
      "eslint-plugin-vue": "^10.10.0",
      "happy-dom": "^20.11.1",
      "jiti": "^2.7.0",
      "notivue": "^2.4.5",
      "npm-run-all2": "^9.0.3",
      "postcss": "^8.5.25",
      "tailwindcss": "^3.4.19",
      "typescript": "~6.0.3",
      "vite": "^8.1.5",
      "vite-plugin-vue-devtools": "^8.2.1",
      "vitest": "^4.1.10",
      "vitest-axe": "^0.1.0",
      "vue-tsc": "^3.3.8"
   },
   "overrides": {
      "glob": "^13"
   }
}
